import { Route, RouteConfig } from 'vue-router';
import Access from './access.vue';
import SignIn from './signin.vue';
import PasswordRecovery from './password-recovery.vue';
import PasswordUpdate from './password-update.vue';
import * as actions from './actions';

interface User {
    id: number;
    handle?: string;
    displayName: string;
    isRegistered?: boolean;
    isConfirmed?: boolean;
}

type routeParamsFunction = (route: Route) => any;

function createRoutes(routeParams: routeParamsFunction, successRouteName: string) {
    return [
        {
            path: 'signin',
            name: 'access-signin',
            component: SignIn,
            props: (route) => ({
                successRoute: { name: successRouteName, params: routeParams(route) },
                passwordRecoveryRoute: { name: 'access-password-recovery', params: routeParams(route) }
            })
        },
        {
            path: 'password-recovery',
            name: 'access-password-recovery',
            component: PasswordRecovery,
            props: (route) => ({
                signinRoute: { name: 'access-signin', params: routeParams(route) },
                updateLinkPrefix: route.path.replace('access/password-recovery', '')
            })
        },
        {
            path: 'password-update',
            name: 'access-password-update',
            component: PasswordUpdate,
            props: (route) => ({
                signinRoute: { name: 'access-signin', params: routeParams(route) },
                passwordRecoveryRoute: { name: 'access-password-recovery', params: routeParams(route) }
            })
        }
    ]
}

export {
    User,
    Access,
    actions,
    createRoutes
}


// WEBPACK FOOTER //
// ./src/dndg/access/index.ts